import { render, staticRenderFns } from "./TableCouponList.vue?vue&type=template&id=7ddaa668&scoped=true&"
import script from "./TableCouponList.vue?vue&type=script&lang=js&"
export * from "./TableCouponList.vue?vue&type=script&lang=js&"
import style0 from "./TableCouponList.vue?vue&type=style&index=0&id=7ddaa668&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ddaa668",
  null
  
)

export default component.exports